export type {IntervalInputProps} from './IntervalInput.interface';
export {IntervalInput} from "./IntervalInput";